import { useState } from "react";
import {
  loadRecovery,
  saveRecovery,
  clearRecovery,
  hasResumableWork,
  type RecoverySnapshot,
} from "../lib/recovery";

export function useRecovery() {
  // Read once at mount. The flag is mirror state for the UI; the source of
  // truth is localStorage and is consulted directly by save/load/clear.
  const [hasRecoveryData, setHasRecoveryData] = useState<boolean>(() =>
    hasResumableWork(loadRecovery())
  );

  function clear() {
    clearRecovery();
    setHasRecoveryData(false);
  }

  function save(snapshot: Omit<RecoverySnapshot, "timestamp">) {
    saveRecovery(snapshot);
  }

  function load(): RecoverySnapshot | null {
    return loadRecovery();
  }

  return { hasRecoveryData, setHasRecoveryData, save, load, clear };
}
